import React from "react";
import { useInView } from "react-intersection-observer";
import "../styles/Contacthero.css";

import parallaxImg from "../assets/pr3A.png";

const Contacthero = () => {
  const [box1Ref, box1InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [box2Ref, box2InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [detailRef, detailInView] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [addressRef, addressInView] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [mapRef, mapInView] = useInView({ triggerOnce: true, threshold: 0.4 });

  return (
    <div className="contacthero-container">
      <div
        className="contacthero-parallax-section"
        style={{ backgroundImage: `url(${parallaxImg})` }}
      />

      <div
        ref={addressRef}
        className={`contacthero-addresses ${addressInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-address-box">
          <h3>Dubai [UAE]</h3>
          <p>
            Acume Electrical Engineering Services LLC<br />
            No. 302, Al Mansour Building,<br />
            P.O. Box: 379569,<br />
            DUBAI,<br />
            UAE.<br />
            Email: <a href="mailto:services@acume.ae"> services@acume.ae</a><br />
            Mobile: Ph: +971 4 263 4821, Fax: +971 4 269 9143
          </p>
        </div>
         <div className="contacthero-address-box">
          <h3>Abu Dhabi [UAE]</h3>
          <p>
            Acume Engineering Contracting LLC<br />
           No. M-02, C-63 Building,<br />
            Musaffah Community Shabiya 10,<br />
           P.O. Box: 32109,<br />
           Abu Dhabi<br />
            Email: <a href="mailto:services@acume.ae"> services@acume.ae</a><br />
            Mobile: Ph: +971 2 565 2100, Fax: +971 4 269 9143
          </p>
        </div>

        <div className="contacthero-address-box">
          <h3>Kingdom Of Saudi Arabia</h3>
          <p>
            Acume Company Ltd<br />
            King Abdul Aziz Street,<br />
            Aziziyah,<br />
            PO Box 41,Dammam 32424<br />
            Email: <a href="mailto:services.ksa@acumegcc.com">services.ksa@acumegcc.com</a><br />
            Mobile: +966538269720
          </p>
        </div>
      </div>

      {/* Two Maps Side by Side */}
      <div
        ref={mapRef}
        className={`contacthero-map-wrapper ${mapInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-map-box">
     <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4439.1563475171!2d55.3849353753845!3d25.28083287765719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDE2JzUxLjAiTiA1NcKwMjMnMTUuMCJF!5e1!3m2!1sen!2sin!4v1748948063770!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>

        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4472.368574014841!2d54.487144475354846!3d24.357398978261052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDIxJzI2LjYiTiA1NMKwMjknMjMuMCJF!5e1!3m2!1sen!2sin!4v1748947264295!5m2!1sen!2sin" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>


        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4395.31276262869!2d50.06094727542369!3d26.453675376923762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDI3JzEzLjIiTiA1MMKwMDMnNDguNyJF!5e1!3m2!1sen!2sin!4v1748947187791!5m2!1sen!2sin" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          
        </div>
        
      </div>
    </div>
  );
};

export default Contacthero;
